const styles = {
  root: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      height: '45px',
    },
  },
  box: {
    display: 'flex',
    flexDirection: 'row',
    gap: '24px',
    alignItems: 'center',
    justifyContent: 'center',
  },
  labelTypeSelector: {
    color: '#647886',
    fontFamily: 'Barlow Condensed',
    fontWeight: 600,
    fontSize: 18,
    textTransform: 'uppercase',
    marginBottom: 0,
  },
};

export default styles;
